export const createCtx = defaultVal => {
  let _value;
  const provide = val => {
    _value = val;
  };
  if (defaultVal !== undefined) {
    provide(defaultVal);
  }
  const _getValue = () => _value;
  const getValue = () => {
    if (_value === undefined) {
      const err = new Error('reading not provided context');
      console.error(err);
      throw err;
    }
    return _value;
  };
  return {
    provide,
    getValue,
    _getValue
  };
};
export const withContexts = (values, fn) => {
  return function () {
    const cleanups = values.map(_ref => {
      let {
        ctx,
        val
      } = _ref;
      const prevValue = ctx._getValue();
      ctx.provide(val);
      return () => {
        ctx.provide(prevValue);
      };
    });
    const res = fn(...arguments);
    cleanups.forEach(clean => clean());
    return res;
  };
};
//# sourceMappingURL=context.js.map